import { clickProvider } from "./providers/click";
import {
  validateStoriciRequest,
  validateCatalogClickStatsRequest,
} from "./schemas/clickSchemas";

const clickService = {
  click: async (data) => {
    return clickProvider.click(data);
  },

  storici: async (data) => {
    const payload = validateStoriciRequest(data);
    return clickProvider.storici(payload);
  },

  fetchCatalogClickStats: async (data) => {
    const { catalogListId, nome } = validateCatalogClickStatsRequest(data);
    return clickProvider.click({ catalogListId, nome });
  },
};

export default clickService;